<template>
    <svg width="100%" height="100%" viewBox="0 0 33 33" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Comps" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" >
            <g id="Photo-View" transform="translate(-1178.000000, -926.000000)" fill-rule="nonzero">
                <g id="Btn-x" transform="translate(1178.000000, 926.000000)">
                    <g id="Button/Round/Plus" transform="translate(0.627417, 0.627417)">
                        <rect id="Rectangle" :fill="fill" transform="translate(16.000000, 16.000000) rotate(-315.000000) translate(-16.000000, -16.000000) " x="15" y="8" width="2" height="16"></rect>
                        <rect id="Rectangle-Copy-13" :fill="fill" transform="translate(16.041595, 15.958405) rotate(-585.000000) translate(-16.041595, -15.958405) " x="15.100418" y="7.95840548" width="1.88235294" height="16"></rect>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "IconClose",
    props: {
        fill: {
            type: String,
            default: '#fff'
		},
    },
};
</script>
